import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TableauViz, Toolbar, TableauEventType } from '@tableau/embedding-api';
import { Snackbar, Alert } from '@mui/material';
import MainLayout from '../Layouts/Mainlayout';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store/store';
import Loader from '../Loader'; 

const ReportPage: React.FC = () => {
  const { reportId } = useParams<{ reportId?: string }>();
  const vizRef = useRef<HTMLDivElement>(null);
  const [token, setToken] = useState<string>('');
  const [reportName, setReportName] = useState<string>('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);
  const tableauToken = useSelector(
    (state: RootState) => state.auth.tableauToken,
  );
  const reportUrl = process.env.REACT_APP_DASHBOARD_REPORT_URL ?? '';
  useEffect(() => {
    console.log('Initial isLoading state:', isLoading);
  }, []);

  useEffect(() => {
    if (tableauToken !== null) {
      const fetchData = async (): Promise<void> => {
        try {
          setToken(tableauToken);
          console.log('Token set:', tableauToken);
        } catch (error) {
          console.error('Error generating token:', error);
          setIsLoading(false);
          setSnackbarMessage('Error loading report. Please try again.');
          setSnackbarOpen(true);
        }
      };

      void fetchData();
    }
  }, [tableauToken]);
  const formatReportId = (id: string): string => {
    return id
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  useEffect(() => {
    if (vizRef.current && token !== '') {
      console.log('Setting up Tableau viz');
      setupTableauViz();
    }
  }, [token, reportId]);

  const setupTableauViz = (): void => {
    setIsLoading(true);

    if (vizRef.current && token !== '') {
      const viz = new TableauViz();
      const reportName = formatReportId(reportId as string);
      setReportName(reportName);

      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      viz.src = `${reportUrl}/${reportName.replace(/\s/g, '')}`;
      viz.hideTabs = true;
      viz.toolbar = Toolbar.Hidden;
      viz.token = token;

      viz.addEventListener(TableauEventType.FirstInteractive, () => {
        console.log('Tableau viz is interactive');
        setIsLoading(false);
      });

      vizRef.current.innerHTML = ''; 
      vizRef.current.appendChild(viz);
    }
  };

  const handleSnackbarClose = (): void => {
    setSnackbarOpen(false);
  };

  console.log('Rendering. isLoading:', isLoading);

  return (
    <div className=" flex flex-row justify-start">
      <MainLayout>
        <div className="relative">
         
          <div className="flex justify-between items-center mb-[20px]">
          <div className="flex justify-between items-center mb-[20px]">
  <div>
    <h1 className="text-2xl text-title font-semibold">
      {reportName.includes('_') ? reportName.split('_')[0] : reportName}
    </h1>
  </div>
</div>

        </div>
          <div
            className="mb-[30px] bg-white rounded-lg p-[20px] overflow-auto relative"
            style={{ minHeight: '500px' }}
          >
            {isLoading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Loader />
              </div>
            )}
            <div
              ref={vizRef}
              className="mt-4"
              style={{ visibility: isLoading ? 'hidden' : 'visible' }}
            />
          </div>

          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <Alert
              onClose={handleSnackbarClose}
              severity="error"
              sx={{ width: '100%' }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      </MainLayout>
    </div>
  );
};

export default ReportPage;
